const areas = [
  {
    slug: "sharjah",
    path: "/areas/sharjah",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.848116567497!2d55.38329977538656!3d25.34287717761749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5bc92e8eac93%3A0x3c85516abfef18aa!2sBell%20Rashid%20Towers%20-%20Corniche%20St%20-%20Al%20Majaz%201%20-%20Al%20Majaz%20-%20Sharjah%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sus!4v1717694266783!5m2!1sen!2sus",
    en: {
      name: "Sharjah",
      country: "United Arab Emirates",
      metaTitle:
        "Engineering Consultants in Sharjah | Sabir Elsir Engineering Consultants",
      metaDescription:
        "Licensed engineering consultancy in Sharjah since 2001. Architectural design, structural engineering, MEP, municipality approvals, and site supervision from our Al Majaz head office.",
      eyebrow: "Areas we serve · United Arab Emirates",
      heading: "Engineering Consultants in Sharjah",
      summary:
        "Our head office on Corniche Street in Al Majaz has served Sharjah since 2001. As a consultancy approved by Sharjah Municipality, SEWA, and the Civil Defense, we prepare authority-ready designs and guide projects from concept to final permit.",
      cardBlurb:
        "Head office. Architectural and structural design, municipal approvals, and site supervision across the emirate since 2001.",
      servicesTitle: "Engineering services in Sharjah",
      services: [
        "Architectural design",
        "Structural design and analysis",
        "MEP engineering",
        "Building permits and municipality approvals",
        "Civil Defense and SEWA approvals coordination",
        "Engineering site supervision",
        "Project management",
        "Interior design",
        "Modern villa and mosque design",
      ],
      localTitle: "Local approvals expertise in Sharjah",
      localPoints: [
        "Designs prepared to Sharjah Municipality building codes and the UAE Fire and Life Safety Code.",
        "Coordinated submissions for SEWA utility approvals and Civil Defense NOCs.",
        "Soil investigation coordination with approved geotechnical laboratories.",
        "Structural calculations and CAD/BIM drawings formatted for municipal review.",
      ],
      officeTitle: "Our Sharjah office",
      officeAddress:
        "Bell Rashid Towers, Corniche Street, Al Majaz 1, Sharjah, United Arab Emirates",
      mapTitle: "Sabir Elsir Engineering Consultants – Sharjah office map",
      ctaText:
        "Planning a project in Sharjah? Talk to our engineering team about design, approvals, and supervision.",
      ctaLink: "Contact our team",
    },
    ar: {
      name: "الشارقة",
      country: "الإمارات العربية المتحدة",
      metaTitle: "استشاريون هندسيون في الشارقة | صابر السر للاستشارات الهندسية",
      metaDescription:
        "مكتب استشارات هندسية مرخص في الشارقة منذ عام 2001. تصميم معماري وهندسة إنشائية وأعمال كهروميكانيكية واعتمادات البلدية والإشراف على المواقع من مكتبنا الرئيسي في المجاز.",
      eyebrow: "المناطق التي نخدمها · الإمارات العربية المتحدة",
      heading: "استشاريون هندسيون في الشارقة",
      summary:
        "يخدم مكتبنا الرئيسي على شارع الكورنيش في المجاز إمارة الشارقة منذ عام 2001. وبصفتنا مكتب استشارات معتمداً لدى بلدية الشارقة وهيئة كهرباء ومياه الشارقة والدفاع المدني، نُعدّ تصاميم جاهزة للاعتماد ونرافق المشاريع من الفكرة حتى الرخصة النهائية.",
      cardBlurb:
        "المكتب الرئيسي. تصميم معماري وإنشائي واعتمادات بلدية وإشراف على المواقع في جميع أنحاء الإمارة منذ عام 2001.",
      servicesTitle: "الخدمات الهندسية في الشارقة",
      services: [
        "التصميم المعماري",
        "التصميم والتحليل الإنشائي",
        "الهندسة الكهروميكانيكية",
        "تصاريح البناء واعتمادات البلدية",
        "تنسيق اعتمادات الدفاع المدني وهيئة كهرباء ومياه الشارقة",
        "الإشراف الهندسي على المواقع",
        "إدارة المشاريع",
        "التصميم الداخلي",
        "تصميم الفلل الحديثة والمساجد",
      ],
      localTitle: "خبرة في إجراءات الاعتماد المحلية بالشارقة",
      localPoints: [
        "إعداد التصاميم وفق اشتراطات بلدية الشارقة وكود الإمارات للوقاية والسلامة من الحريق.",
        "تنسيق التقديمات لاعتمادات هيئة كهرباء ومياه الشارقة وشهادات عدم الممانعة من الدفاع المدني.",
        "تنسيق فحوصات التربة مع مختبرات جيوتقنية معتمدة.",
        "إعداد الحسابات الإنشائية ومخططات CAD/BIM بصيغة مناسبة للمراجعة البلدية.",
      ],
      officeTitle: "مكتبنا في الشارقة",
      officeAddress:
        "أبراج بيل راشد، شارع الكورنيش، المجاز 1، الشارقة، الإمارات العربية المتحدة",
      mapTitle: "صابر السر للاستشارات الهندسية – خريطة مكتب الشارقة",
      ctaText:
        "تخطط لمشروع في الشارقة؟ تحدث مع فريقنا الهندسي عن التصميم والاعتمادات والإشراف.",
      ctaLink: "تواصل مع فريقنا",
    },
  },
  {
    slug: "ajman",
    path: "/areas/ajman",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14414.321060014643!2d55.428171159773186!3d25.41885697013976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5770f5c0c4af%3A0xe23009abbf0652b4!2sAl%20Owan%20-%20Al%20Nakhil%202%20-%20Ajman%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sus!4v1717700155252!5m2!1sen!2sus",
    en: {
      name: "Ajman",
      country: "United Arab Emirates",
      metaTitle:
        "Engineering Consultants in Ajman | Sabir Elsir Engineering Consultants",
      metaDescription:
        "Engineering consultancy in Ajman for villa, residential, and commercial projects. Architectural and structural design, Ajman Municipality approvals, and site supervision from our Al Nakhil office.",
      eyebrow: "Areas we serve · United Arab Emirates",
      heading: "Engineering Consultants in Ajman",
      summary:
        "From our office in Al Nakhil, we support villa, residential, and commercial projects across Ajman with architectural and structural design, municipality approvals, and on-site engineering supervision.",
      cardBlurb:
        "Design, approvals, and supervision for villa, residential, and commercial projects across Ajman.",
      servicesTitle: "Engineering services in Ajman",
      services: [
        "Architectural design",
        "Structural design and analysis",
        "MEP engineering",
        "Building permits and Ajman Municipality approvals",
        "Civil Defense and utility approvals coordination",
        "Engineering site supervision",
        "Project management",
        "Interior design",
        "Modern villa design",
      ],
      localTitle: "Local approvals expertise in Ajman",
      localPoints: [
        "Designs aligned with Ajman Municipality requirements and the UAE Fire and Life Safety Code.",
        "Coordinated submissions for Civil Defense NOCs and utility approvals.",
        "Soil investigation coordination with approved geotechnical laboratories.",
        "Complete design and calculation packages prepared for a smoother municipal review.",
      ],
      officeTitle: "Our Ajman office",
      officeAddress: "Al Owan, Al Nakhil 2, Ajman, United Arab Emirates",
      mapTitle: "Sabir Elsir Engineering Consultants – Ajman office map",
      ctaText:
        "Planning a project in Ajman? Talk to our engineering team about design, approvals, and supervision.",
      ctaLink: "Contact our team",
    },
    ar: {
      name: "عجمان",
      country: "الإمارات العربية المتحدة",
      metaTitle: "استشاريون هندسيون في عجمان | صابر السر للاستشارات الهندسية",
      metaDescription:
        "مكتب استشارات هندسية في عجمان لمشاريع الفلل والمباني السكنية والتجارية. تصميم معماري وإنشائي واعتمادات بلدية عجمان وإشراف على المواقع من مكتبنا في النخيل.",
      eyebrow: "المناطق التي نخدمها · الإمارات العربية المتحدة",
      heading: "استشاريون هندسيون في عجمان",
      summary:
        "من مكتبنا في النخيل، ندعم مشاريع الفلل والمباني السكنية والتجارية في جميع أنحاء عجمان بالتصميم المعماري والإنشائي واعتمادات البلدية والإشراف الهندسي على المواقع.",
      cardBlurb:
        "تصميم واعتمادات وإشراف لمشاريع الفلل والمباني السكنية والتجارية في جميع أنحاء عجمان.",
      servicesTitle: "الخدمات الهندسية في عجمان",
      services: [
        "التصميم المعماري",
        "التصميم والتحليل الإنشائي",
        "الهندسة الكهروميكانيكية",
        "تصاريح البناء واعتمادات بلدية عجمان",
        "تنسيق اعتمادات الدفاع المدني والمرافق",
        "الإشراف الهندسي على المواقع",
        "إدارة المشاريع",
        "التصميم الداخلي",
        "تصميم الفلل الحديثة",
      ],
      localTitle: "خبرة في إجراءات الاعتماد المحلية بعجمان",
      localPoints: [
        "إعداد التصاميم وفق متطلبات بلدية عجمان وكود الإمارات للوقاية والسلامة من الحريق.",
        "تنسيق التقديمات لشهادات عدم الممانعة من الدفاع المدني واعتمادات المرافق.",
        "تنسيق فحوصات التربة مع مختبرات جيوتقنية معتمدة.",
        "إعداد حزم تصميم وحسابات متكاملة لمراجعة بلدية أكثر سلاسة.",
      ],
      officeTitle: "مكتبنا في عجمان",
      officeAddress: "العوان، النخيل 2، عجمان، الإمارات العربية المتحدة",
      mapTitle: "صابر السر للاستشارات الهندسية – خريطة مكتب عجمان",
      ctaText:
        "تخطط لمشروع في عجمان؟ تحدث مع فريقنا الهندسي عن التصميم والاعتمادات والإشراف.",
      ctaLink: "تواصل مع فريقنا",
    },
  },
  {
    slug: "khartoum",
    path: "/areas/khartoum",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d985.7143868319603!2d32.558500725483576!3d15.595707697674648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x168e91b00d257a39%3A0x30ba9f11fdf738be!2z2LnZhdin2LHYqSDYp9mE2KjYr9ix!5e0!3m2!1sen!2sus!4v1718587546236!5m2!1sen!2sus",
    en: {
      name: "Khartoum",
      country: "Sudan",
      metaTitle:
        "Engineering Consultants in Khartoum | Sabir Elsir Engineering Consultants",
      metaDescription:
        "Structural integrity assessment, damage inspection, rehabilitation planning, and engineering design services in Khartoum, Sudan, from Sabir Elsir Engineering Consultants.",
      eyebrow: "Areas we serve · Sudan",
      heading: "Engineering Consultants in Khartoum",
      summary:
        "From our Khartoum office, we provide structural integrity assessments, damage inspection, and rehabilitation planning, alongside architectural and structural design for new projects across Sudan.",
      cardBlurb:
        "Structural assessment, rehabilitation planning, and engineering design services in Sudan's capital.",
      servicesTitle: "Engineering services in Khartoum",
      services: [
        "Structural integrity assessment",
        "Building damage inspection and assessment",
        "Non-destructive testing coordination",
        "Rehabilitation and repair planning",
        "Architectural and structural design",
        "Infrastructure rehabilitation",
        "Project management",
      ],
      localTitle: "Assessment and rehabilitation expertise in Khartoum",
      localPoints: [
        "Visual inspection combined with non-destructive testing (NDT) and concrete core sampling.",
        "Geotechnical investigation to evaluate foundations and site conditions.",
        "Damage classification and prioritised repair recommendations.",
        "Seismic and environmental considerations integrated into rehabilitation design.",
      ],
      officeTitle: "Our Khartoum office",
      officeAddress: "Khartoum, Sudan",
      mapTitle: "Sabir Elsir Engineering Consultants – Khartoum office map",
      ctaText:
        "Need structural assessment, rehabilitation planning, or design services in Khartoum? Talk to our engineering team.",
      ctaLink: "Contact our team",
    },
    ar: {
      name: "الخرطوم",
      country: "السودان",
      metaTitle: "استشاريون هندسيون في الخرطوم | صابر السر للاستشارات الهندسية",
      metaDescription:
        "خدمات تقييم السلامة الإنشائية وفحص الأضرار وتخطيط أعمال التأهيل والتصميم الهندسي في الخرطوم، السودان، من صابر السر للاستشارات الهندسية.",
      eyebrow: "المناطق التي نخدمها · السودان",
      heading: "استشاريون هندسيون في الخرطوم",
      summary:
        "من مكتبنا في الخرطوم، نقدم خدمات تقييم السلامة الإنشائية وفحص الأضرار وتخطيط أعمال التأهيل، إلى جانب التصميم المعماري والإنشائي للمشاريع الجديدة في جميع أنحاء السودان.",
      cardBlurb:
        "خدمات التقييم الإنشائي وتخطيط التأهيل والتصميم الهندسي في العاصمة السودانية.",
      servicesTitle: "الخدمات الهندسية في الخرطوم",
      services: [
        "تقييم السلامة الإنشائية",
        "فحص وتقييم أضرار المباني",
        "تنسيق الفحوصات غير المتلفة",
        "تخطيط أعمال التأهيل والإصلاح",
        "التصميم المعماري والإنشائي",
        "تأهيل البنية التحتية",
        "إدارة المشاريع",
      ],
      localTitle: "خبرة في التقييم والتأهيل بالخرطوم",
      localPoints: [
        "الفحص البصري مدعوماً بالفحوصات غير المتلفة وأخذ عينات لبّ الخرسانة.",
        "التحقيقات الجيوتقنية لتقييم الأساسات وظروف الموقع.",
        "تصنيف الأضرار وتوصيات إصلاح مرتبة حسب الأولوية.",
        "دمج اعتبارات الزلازل والبيئة في تصميم أعمال التأهيل.",
      ],
      officeTitle: "مكتبنا في الخرطوم",
      officeAddress: "الخرطوم، السودان",
      mapTitle: "صابر السر للاستشارات الهندسية – خريطة مكتب الخرطوم",
      ctaText:
        "تحتاج إلى تقييم إنشائي أو تخطيط أعمال تأهيل أو خدمات تصميم في الخرطوم؟ تحدث مع فريقنا الهندسي.",
      ctaLink: "تواصل مع فريقنا",
    },
  },
];

export default areas;
